import { useEffect } from "react";
import { bootstrapLocation } from "@/hooks/useGeolocation";

/** How often the shared position is silently refreshed while the tab is open. */
const REFRESH_MS = 10 * 60 * 1000; // 10 minutes

/**
 * Detects the user's location on every app load / refresh (silently, without
 * prompting unless permission was already granted) and keeps it fresh while
 * the app is open, so every map, listing, weather widget and proximity
 * distance in the app uses the same up-to-date origin point.
 */
export default function LocationBootstrap() {
  useEffect(() => {
    // Fresh detection on each refresh — bypasses the cached position.
    void bootstrapLocation(true);

    const interval = window.setInterval(() => void bootstrapLocation(true), REFRESH_MS);

    // Re-detect when the user returns to the tab or regains connectivity.
    const onVisible = () => {
      if (document.visibilityState === "visible") void bootstrapLocation(true);
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("online", onVisible);

    return () => {
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("online", onVisible);
    };
  }, []);
  return null;
}
